import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { MeTeam } from '@scio3/shared-types';
import { ROOT_TEAM_ID } from '@scio3/shared-types';

interface TeamState {
  teams: MeTeam[];
  activeTeamId: string;
  /** Whether the active team is the root/default team */
  isDefaultTeam: boolean;

  setTeams: (teams: MeTeam[]) => void;
  setActiveTeam: (teamId: string) => void;
  getActiveTeam: () => MeTeam | undefined;
  clearTeams: () => void;
}

export const useTeamStore = create<TeamState>()(
  persist(
    (set, get) => ({
      teams: [],
      activeTeamId: '',
      isDefaultTeam: true,

      setTeams: (teams) => {
        const current = get().activeTeamId;
        const isValid = current && teams.some((t) => t._id === current);
        const newTeamId = isValid ? current : (teams[0]?._id ?? '');
        set({
          teams,
          ...(isValid ? {} : { activeTeamId: newTeamId }),
          isDefaultTeam: !newTeamId || newTeamId === ROOT_TEAM_ID,
        });
      },
      setActiveTeam: (teamId) =>
        set({
          activeTeamId: teamId,
          isDefaultTeam: !teamId || teamId === ROOT_TEAM_ID,
        }),
      getActiveTeam: () => get().teams.find((t) => t._id === get().activeTeamId),
      clearTeams: () => set({ teams: [], activeTeamId: '' }),
    }),
    { name: 'scio3-team' },
  ),
);
